import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
  selector: 'adminapp-upload-history-zip',
  templateUrl: './upload-history-zip.component.html',
  styleUrls: ['./upload-history-zip.component.scss']
})
export class UploadHistoryZipComponent implements OnInit {

  @Input()
  selectFile = '';
  @Input()
  name = '';
  @Input()
  preChange: Function;
  @Input()
  disabled: boolean;
  @Output()
  file: EventEmitter<File> = new EventEmitter<File>();
  @Output()
  errorEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('file') fileUploadInput;
  @ViewChild('browse') browseButton;

  constructor() {
  }

  ngOnInit() {
  }

  fileEvent(event: any) {
    const file = event.target.files[0];
    if (file && file.type === 'application/x-zip-compressed') {
      this.selectFile = file.name;
      this.file.emit(file);
    } else {
      this.handleFailure();
    }
  }
  onclick($event) {
    if (this.preChange && !this.preChange()) { $event.preventDefault(); }
    if (this.fileUploadInput) {
      this.fileUploadInput.nativeElement.value = '';
    }
  }

  handleFailure() {
    this.errorEventEmitter.emit();
  }
}
